import React, { useContext } from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import { DefaultButton } from '@fluentui/react';
import { MessageBar, MessageBarBody } from '@fluentui/react-message-bar';
import { I18nContext } from '@bingads-webui-react/i18n-context';

export const BidMessageBar = (props) => {
  const {
    buttonText,
    messageType,
    messageContent,
    onButtonClick,
  } = props;

  const i18n = useContext(I18nContext);
  return (
    <MessageBar
      messageBarType={messageType}
      styles={{ root: { marginTop: 12 } }}
      layout="multiline"
    >
      <MessageBarBody>
        {messageContent}
        {_.isFunction(onButtonClick) && <DefaultButton text={i18n.getString(buttonText)} onClick={onButtonClick} />}
      </MessageBarBody>
    </MessageBar>
  );
};

BidMessageBar.propTypes = {
  messageType: PropTypes.oneOf(['info', 'warning', 'success', 'error']),
  messageContent: PropTypes.string.isRequired,
  onButtonClick: PropTypes.func,
  buttonText: PropTypes.string,
};

BidMessageBar.defaultProps = {
  messageType: 'info',
  onButtonClick: undefined,
  buttonText: _TL_('Set a conversion goal'),
};
